import React from 'react';
import { MDBContainer, MDBDataTable, MDBRow, MDBCol, MDBBtn, MDBSelect, MDBIcon, MDBCard, MDBCardBody } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';
import Formatter from '../Utilities/Formatter';
import DashboardLineGraph from './ComponentFragments/DashboardLineGraph';
import DoughnutChart from './ComponentFragments/DoughnutChart';
import CanvasJSReact from '../Assets/canvasjs.react';
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
export default class UnitHealthCheck extends React.Component {

    constructor(props) {
        super(props);
        this.props.loaderOn();
        this.state = {
            teamData: [],
            yearData: [],
            segmentData: [],
            //toWeekData: [],
            selectedYear: 0,
            selectedSegment: 0,
            //selectedToWeek: 0,
            teamGraphData: {
                labels: [],
                currYTDSales: [],
                prevYTDSales: []
            },
            chartData: [],
            tableHidden: true
        }
        this.formatter = new Formatter();
        this.handleYearSelectChange = this.handleYearSelectChange.bind(this);
        this.handleSegmentSelectChange = this.handleSegmentSelectChange.bind(this);
        this.getUnitHealthCheck = this.getUnitHealthCheck.bind(this);
    }

    async loadSegmentsForYear(year) {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/getsegmentsforyear?yearId=' + year, 200);
        let segData = [];
        result.data.forEach((segment) => segData.push({ checked: false, value: segment.periodId, text: segment.description }));

        segData[0].checked = true;
        this.setState({
            segmentData: segData,
            //toWeekData: toWeeksData,
            selectedSegment: segData[0].value,
            //selectedToWeek: toWeeksData[0].value
        })

        this.props.loaderOff();
    }

    handleYearSelectChange(selected) {
        this.setState({
            selectedYear: selected[0]
        });
        this.loadSegmentsForYear(selected[0])
    }

    handleSegmentSelectChange(selected) {
        this.setState({
            selectedSegment: selected[0]
        });
    }



    async componentWillMount() {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/getyears', 200);
        let yearsData = [];
        result.data[0].forEach((year) => yearsData.push({ checked: false, value: year.value, text: year.label }));
        yearsData[0].checked = true;

        let teamGraphData = {
            labels: [],
            currYTDSales: [],
            prevYTDSales: []
        }
        let graphResponse = await dl.Post('/common/GetGraphData', 1)

        graphResponse.data.forEach((entry) => {
            teamGraphData.labels.push(entry.month);
            teamGraphData.currYTDSales.push(entry.currYr);
            teamGraphData.prevYTDSales.push(entry.prevYr);
        })

        this.setState({
            yearData: yearsData,
            selectedYear: yearsData[0].value,
            teamGraphData: teamGraphData
        })
        this.props.loaderOff();
    }

    async getUnitHealthCheck() {
        this.props.loaderOn();
        var dl = new DataLayer();
        let chartData = [];
        let months = await dl.Get('/demonstrator/getSegments?segmentId=' + this.state.selectedSegment, 200);
        await dl.Get('/demonstrator/GetUnitHealthCheck?segmentId=' + this.state.selectedSegment, 200).then((response) => {
            let demRecs = [];
            let rec;
            let healthy = 0;
            let sick = 0;
            let critical = 0;
            let m1c = false;
            let m1h = false;
            let m2c = false;
            let m2h = false;
            let m3c = false;
            let m3h = false;
            let overAllScore = 0;
            response.data.map((unit) => {
                if (unit.unitCode.trim() == '031C366') {
                    var shdsshdchsd = "";
                }
                if (unit.month1Sales < unit.month1QualLevel) {
                    m1c = true;
                } else {
                    if ((unit.month1Sales - unit.month1QualLevel) > 2000) {
                        m1h = true;
                        overAllScore = overAllScore + 2
                    } else {
                        overAllScore = overAllScore + 1;
                    }
                }

                if (unit.month2Sales < unit.month2QualLevel) {
                    m2c = true;
                } else {
                    if ((unit.month2Sales - unit.month2QualLevel) > 2000) {
                        m2h = true;
                        overAllScore = overAllScore + 2
                    } else {
                        overAllScore = overAllScore + 1
                    }
                }

                if (unit.month3Sales < unit.month3QualLevel) {
                    m3c = true;
                } else {
                    if ((unit.month3Sales - unit.month3QualLevel) > 2000) {
                        m3h = true;
                        overAllScore = overAllScore + 2
                    } else {
                        overAllScore = overAllScore + 1
                    }
                }

                if (overAllScore == 0) {
                    critical++;
                }
                if (overAllScore == 6) {
                    healthy++;
                }
                if (overAllScore > 0 && overAllScore < 6) {
                    sick++;
                }

                rec = {
                    //secondGen: perfRec.secondGen ? [<i key="cell1" className="far fa-thumbs-up mr-2 green-text" aria-hidden="true"></i>] : [<i key="cell1" className="far fa-times-circle mr-2 red-text" aria-hidden="true"></i>],
                    overallHealth: overAllScore == 0 ? [<MDBIcon size="lg" className="red-text" far icon="frown" />] : overAllScore == 6 ? [<MDBIcon size="lg" className="green-text" far icon="grin" />] : [<MDBIcon size="lg" className="orange-text" far icon="meh" />],
                    unitCode: unit.unitCode,
                    unitName: unit.unitName,
                    unitStartWeek: unit.unitStartWeek,
                    month1Status: unit.month1Status,
                    month1QualLevel: unit.month1QualLevel,
                    month1Sales: unit.month1Sales,
                    month1Health: m1c ? [<MDBIcon size="lg" className="red-text" far icon="frown" />] : m1h ? [<MDBIcon size="lg" className="green-text" far icon="grin" />] : [<MDBIcon size="lg" className="orange-text" far icon="meh" />],
                    month2Status: unit.month2Status,
                    month2QualLevel: unit.month2QualLevel,
                    month2Sales: unit.month2Sales,
                    month2Health: m2c ? [<MDBIcon size="lg" className="red-text" far icon="frown" />] : m2h ? [<MDBIcon size="lg" className="green-text" far icon="grin" />] : [<MDBIcon size="lg" className="orange-text" far icon="meh" />],
                    month3Status: unit.month3Status,
                    month3QualLevel: unit.month3QualLevel,
                    month3Sales: unit.month3Sales,
                    month3Health: m3c ? [<MDBIcon size="lg" className="red-text" far icon="frown" />] : m3h ? [<MDBIcon size="lg" className="green-text" far icon="grin" />] : [<MDBIcon size="lg" className="orange-text" far icon="meh" />],
                }
                demRecs.push(rec);
                m1c = false;
                m1h = false;
                m2c = false;
                m2h = false;
                m3c = false;
                m3h = false;
                overAllScore = 0;
            });

            chartData.push({ name: "Healthy", y: healthy, exploded: true, color:"green" }, {name: "Unwell", y: sick, exploded: true, color:"orange"}, {name: "Critical", y: critical, exploded:true, color: "red"})

            let tableData = {
                columns: [{
                    label: 'Overall Health',
                    field: 'overallHealth',
                    sort: 'asc'
                }, {
                    label: 'Unit Code',
                    field: 'unitCode',
                    sort: 'asc'
                }, {
                    label: 'Unit Name',
                    field: 'unitName',
                    sort: 'asc'
                },
                {
                    label: 'Start Week',
                    field: 'unitStartWeek',
                    sort: 'asc'
                },
                {
                    label: months.data[0].description + ' Status',
                    field: 'month1Status',
                    sort: 'asc'
                }, {
                    label: months.data[0].description + ' Level',
                    field: 'month1QualLevel',
                    sort: 'asc'
                }, {
                    label: months.data[0].description + ' Sales',
                    field: 'month1Sales',
                    sort: 'asc'
                }, {
                    label: months.data[0].description + ' Health',
                    field: 'month1Health',
                    sort: 'asc'
                }, {
                    label: months.data[1].description + ' Status',
                    field: 'month2Status',
                    sort: 'asc'
                }, {
                    label: months.data[1].description + ' Level',
                    field: 'month1QualLevel',
                    sort: 'asc'
                }, {
                    label: months.data[1].description + ' Sales',
                    field: 'month1Sales',
                    sort: 'asc'
                }, {
                    label: months.data[1].description + ' Health',
                    field: 'month2Health',
                    sort: 'asc'
                }, {
                    label: months.data[2].description + ' Status',
                    field: 'month1Status',
                    sort: 'asc'
                }, {
                    label: months.data[2].description + ' Level',
                    field: 'month1QualLevel',
                    sort: 'asc'
                }, {
                    label: months.data[2].description + ' Sales',
                    field: 'month1Sales',
                    sort: 'asc'
                }, {
                    label: months.data[2].description + ' Health',
                    field: 'month3Health',
                    sort: 'asc'
                }],
                rows: demRecs
            }

            this.setState({
                teamData: tableData,
                tableHidden: false,
                chartData: chartData
            });
            this.props.loaderOff();
        })


    }

    render() {
        const data = this.state.chartData
        const options = {
            animationEnabled: true,
            title: {
                text: "Units Health"
            },
            //subtitles: [{
            //	text: "71% Positive",
            //	verticalAlign: "center",
            //	fontSize: 24,
            //	dockInsidePlotArea: true
            //}],
            data: [{
                type: "doughnut",
                showInLegend: true,
                indexLabel: "{name}: {y}",
                yValueFormatString: "#,###",
                dataPoints: data
                //dataPoints: [
                //	{ name: "Unsatisfied", y: 5 },
                //	{ name: "Very Unsatisfied", y: 31 },
                //	{ name: "Very Satisfied", y: 40 },
                //	{ name: "Satisfied", y: 17 },
                //	{ name: "Neutral", y: 7 }
                //]
            }]
        }
        return (
            <div>
                <Header headerText='Team Unit Health Check'
                    subHeaderText="(Click Go to load team units health check report)"
                    hideSearch='true'
                />
                
                <MDBCard>
                    <MDBCardBody>
                <MDBRow>
                    <MDBCol md="6">
                        <MDBContainer>
                            <MDBRow className="mt-3">
                                <MDBCol>
                                    <MDBSelect label="Year..."
                                        options={this.state.yearData}
                                        selected="Filter"
                                        getValue={this.handleYearSelectChange}
                                        required
                                    />
                                </MDBCol>

                            </MDBRow>
                            <MDBRow className="mt-3">
                                <MDBCol>
                                    <MDBSelect label="Segment..."
                                        options={this.state.segmentData}
                                        selected="Filter"
                                        getValue={this.handleSegmentSelectChange}
                                        required
                                    />
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol>
                                    <MDBBtn onClick={this.getUnitHealthCheck}>Go</MDBBtn>
                                </MDBCol>
                            </MDBRow>
                        </MDBContainer>
                    </MDBCol>

                    <MDBCol md="6">
                        <MDBContainer>
                            <CanvasJSChart options={options} />
                        </MDBContainer>
                    </MDBCol>
                </MDBRow>
                
                <br />

                <div hidden={this.state.tableHidden}>
                    <hr />
                    <MDBContainer>
                        <MDBRow>
                            <div style={{ fontWeight: "bold" }}>Team Units Results<br />Segment - {this.state.selectedSegment}</div>
                        </MDBRow>
                        <MDBRow>
                            <div>(Showing unit performance results for selected segment)</div>
                        </MDBRow>
                    </MDBContainer>
                    <MDBDataTable
                        responsive
                        striped
                        bordered
                        hover
                        data={this.state.teamData}
                        paging={false}
                        autoWidth
                        maxHeight={"100px"}
                    />

                        </div>
                        </MDBCardBody>
                        </MDBCard>
                    
            </div>
        );
    }


}
